/*!
 * Copyright 2020 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { Drug } from "@trec/api/drug-store";

export const ONCO_DRUGS: Drug[] = [
  // Important! Do not change order!
  {
    name: "XELODA*60CPR RIV 150MG",
    _id: "035219017",
    active_ingredient: "CAPECITABINA",
    box: "BLISTER",
    form: "COMPRESSE RIVESTITE",
  },
  {
    name: "XELODA*120CPR RIV 500MG",
    _id: "035219029",
    active_ingredient: "CAPECITABINA",
    box: "BLISTER",
    form: "COMPRESSE RIVESTITE",
  },
];

export const ONCO_DRUGS_IDS: string[] = ONCO_DRUGS.map((drug) => drug._id);
